import { Column } from './Column';
import { Row } from './Row';

export const Flex = {
  Row,
  Column,
} as const;
